import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-hero">
      {/* Subtle decorative orbs */}
      <div className="absolute top-20 right-[15%] w-64 h-64 rounded-full bg-accent/[0.04] blur-3xl animate-float-slow" />
      <div className="absolute bottom-32 left-[10%] w-48 h-48 rounded-full bg-sage/20 blur-3xl animate-float" />
      <div className="absolute top-[40%] left-[60%] w-3 h-3 rounded-full bg-accent/20 animate-pulse-soft" />
      <div className="absolute top-[30%] left-[20%] w-2 h-2 rounded-full bg-success/15 animate-pulse-soft" style={{ animationDelay: '1s' }} />
      <div className="absolute top-[60%] right-[25%] w-2.5 h-2.5 rounded-full bg-accent/15 animate-pulse-soft" style={{ animationDelay: '2s' }} />

      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-32 pb-24 text-center">
        {/* Main headline — bold, centered, impactful like competitor */}
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-foreground leading-[1.1] tracking-tight mb-8"
        >
          ESSERCI.
          <br />
          ANCHE DOPO.
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto mb-12"
        >
          Crea uno spazio dove i tuoi cari possano sentire la tua voce, percepire
          il tuo carattere e ricevere il tuo supporto — in qualsiasi momento,
          anche tra molti anni.
        </motion.p>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          <Button variant="premium" size="xl" className="group text-base px-12" asChild>
            <Link to="/register">
              Inizia Ora
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};
